import { Component, inject, ChangeDetectionStrategy, OnInit, OnDestroy, ContentChild, TemplateRef } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { NgTemplateOutlet } from '@angular/common';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { DEFAULT_LIST_PAGINATION, ListPagination } from './risr-list-models';
import { RisrList } from './risr-list';
import { LoggerService } from '../logger';
import { RisrPaginatorDirective } from '../pagination';
import { RisrListFilter } from './risr-list-filter';

@Component({
  selector: 'risr-list-view',
  standalone: true,
  imports: [
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    NgTemplateOutlet,
    RisrPaginatorDirective,
    RisrListFilter
  ],
  templateUrl: './risr-list-view.html',
  styles: [`
    .empty-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 48px 16px;
      color: rgba(0, 0, 0, 0.54);
    }
    .empty-state mat-icon {
      font-size: 48px;
      width: 48px;
      height: 48px;
      margin-bottom: 16px;
    }
    .empty-state p {
      font-size: 16px;
      margin: 0;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RisrListView implements OnInit, OnDestroy {

  private list = inject<RisrList<any>>(RisrList);
  private logger = inject(LoggerService).scope('ListView');
  private route = inject(ActivatedRoute)

  @ContentChild('itemTemplate') itemTemplate?: TemplateRef<any>;

  protected listResource = this.list.resource;

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: ParamMap) => {
      const pagination: ListPagination = {
        page: Number(params.get('page')) || DEFAULT_LIST_PAGINATION.page,
        pageSize: Number(params.get('pageSize')) || DEFAULT_LIST_PAGINATION.pageSize
      };
      this.list.updatePagination(pagination);

      const sortOn = params.get('sort_on');
      const sortOrder = params.get('sort_order');
      if (sortOn) {
        this.list.updateSort({
          sort_on: sortOn,
          sort_order: (sortOrder as 'asc' | 'desc') || 'asc'
        });
      }

      const filter = RisrList.parseFilterParams(params.keys, key => params.get(key));
      if (Object.keys(filter).length > 0) {
        this.list.updateFilter(filter);
      }
    });
  }

  updatePage(event: PageEvent) {
    this.list.updatePagination({
      page: event.pageIndex,
      pageSize: event.pageSize
    });
  }

  ngOnDestroy() {
    this.logger.info('Destroying ListView');
    this.list.destroy();
  }
}
